<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 15L9 18L12 21M9 18H14C17.866 18 21 14.866 21 11C21 8.2076 19.3649 5.7971 17 4.67363M5 17.3264C2.63505 16.2029 1 13.7924 1 11C1 7.13401 4.13401 4 8 4H13M10 7L13 4L10 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="#E5E5E5"/>
</svg>
